module.exports = __webpack_public_path__ + "static/media/Data_insight_3-2.d02258b4.svg";